var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128047(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:none;}.cls-2,.cls-3{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-3{fill-rule:evenodd;}.cls-4{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.6,
    y1: 106.65,
    x2: 86.71,
    y2: 106.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.84,104.24a12.32,12.32,0,1,0-12.31,12.32A12.31,12.31,0,0,0,42.84,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.1,104.24a12.32,12.32,0,1,0-12.31,12.32A12.31,12.31,0,0,0,111.1,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.06,63.11H50.27A13.64,13.64,0,0,0,42,66.72c-4.67,4.28-14.77,13-14.77,13S21,81,18,81.42C13.32,82.14,9.4,85.28,9.4,90v9.27c0,4.72,3.86,7.38,8.58,7.38h.47a12.71,12.71,0,0,1-.24-2.41A12.33,12.33,0,0,1,35.84,93.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.1,106.65c4.73,0,7.5-2.66,7.5-7.38V90c0-4.72-3.91-7.86-8.58-8.58-3-.46-9.29-1.73-9.29-1.73S90.63,71,86,66.72a13.64,13.64,0,0,0-8.23-3.61H73.87"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.64,
    y1: 79.64,
    x2: 100.36,
    y2: 79.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.74,104.24a7.22,7.22,0,1,0-7.21,7.22A7.21,7.21,0,0,0,37.74,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106,104.24a7.22,7.22,0,1,0-7.21,7.22A7.21,7.21,0,0,0,106,104.24Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 66.62,
    y1: 79.64,
    x2: 66.62,
    y2: 106.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.38,
    y1: 87.19,
    x2: 56.13,
    y2: 87.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.36,81.94c0,6.52-3.78,11.81-8.44,11.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.08,87.19h-2a2,2,0,0,0-2,2v5.18a2,2,0,0,0,2,2h2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.19,68.06a9.88,9.88,0,1,1,17.49,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.37,
    y1: 68.44,
    x2: 76.62,
    y2: 68.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.44,
    cy: 39.52,
    r: 9.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "67.92 37.43 71.22 35.28 71.22 43.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.34,
    cy: 19.26,
    r: 7.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 128,
    height: 128
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128047);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_047.f7d6febe647bcee2dbf9e2a999176207.svg";
export { ForwardRef as ReactComponent };